<template>
  <div>
    <table class="table">
      <tr>
        <td colspan="2">小盲注值：</td>
      </tr>
      <tr>
        <td rowspan="3" colspan="2" style="padding-right: 100px">
          <el-input
            v-model="mangZhuList"
            type="textarea"
            size="medium"
            :rows="5"
            resize="none"
            placeholder="请输入用户ID，多个ID用英文逗号隔开"
          >
          </el-input>
        </td>
        <template>
          <td>前注值：</td>
          <td>
            <el-input
              placeholder="请输入"
              size="medium"
              type="number"
              style="width: 200px"
              v-model="anteProportion"
            >
              <template slot="append">%</template>
            </el-input>
          </td>
        </template>
      </tr>
      <tr>
        <td colspan="2">初始值 ：{{ rechargeChip | numberChip }}</td>
        <td colspan="2" style="text-align: right">
          <el-button size="medium" type="primary" @click="updateMttMangZhu">更新盲注</el-button>
          <el-button type="primary" @click="showBack()">返回</el-button>
        </td>
      </tr>
    </table>

    <div class="common-table">
      <el-table v-loading="loading" :data="firstList" height="100%" row-key="id">
        <el-table-column align="center">
          <el-table-column align="center" label="等级" prop="grade">
            <template slot-scope="scope">{{ scope.row.grade }}</template>
          </el-table-column>
          <el-table-column align="center" label="小盲" prop="templateName">
            <template slot-scope="scope">{{ scope.row.mangzhu | numberChip }}</template>
          </el-table-column>
          <el-table-column align="center" label="前注" prop="qianzhu">
            <template slot-scope="scope">{{ scope.row.qianzhu | numberChip }}</template>
          </el-table-column>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex';
export default {
  props: ['mangZhuGradeShow'],
  data() {
    return {
      id: null,
      show: false,
      loading: false,
      mangZhuList: '',
      list: [],
      form: {
        id: '',
        templateName: '',
      },
      type: this.mangZhuGradeShow.gameType,
      anteProportion: 0,
      rechargeChip: 0,
      rules: {
        mangzhu: [{ required: true, message: '请输入盲注费', trigger: 'blur' }],
        qianzhu: [{ required: true, message: '请输入前注费', trigger: 'blur' }],
      },
    };
  },
  computed: {
    ...mapState('login', ['permissions']),
    ...mapGetters('mangZhuGrade', ['getMttMazngZhu']),
    firstList() {
      return this.list;
    },
  },
  created() {
    this.getList(this.type);
  },
  methods: {
    ...mapActions('mangZhuGrade', ['getMttMazngZhuList', 'updateMttMazngZhu']),
    getList(type) {
      this.loading = true;
      this.getMttMazngZhuList(type).then((res) => {
        this.loading = false;
        this.list = res.data;
        this.rechargeChip = this.list[0].mangzhu;
        this.close(res);
      });
    },
    updateMttMangZhu() {
      let params = {
        mangZhuList: this.mangZhuList,
        anteProportion: this.anteProportion,
        type: this.type,
      };
      this.updateMttMazngZhu(params).then(() => {
        this.getList(this.type);
      });
    },
    showBack() {
      this.$emit('editBindNoteGradeList', false);
    },
  },
  watch: {
    'mangZhuGradeShow.gameType': {
      handler(val) {
        this.getList(val);
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
